"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatasetType = void 0;
var DatasetType;
exports.DatasetType = DatasetType;

(function (DatasetType) {
  DatasetType["AGGREGATION_STEP"] = "aggregationStep";
  DatasetType["FORMULA_STEP"] = "formulaStep";
  DatasetType["JOIN_STEP"] = "joinStep";
  DatasetType["LOG"] = "log";
  DatasetType["RESOURCE_TYPE"] = "resourceType";
  DatasetType["WORKFLOW"] = "workflow";
})(DatasetType || (exports.DatasetType = DatasetType = {}));